// extracted by mini-css-extract-plugin
module.exports = {"bottomfooter":"Footer_Dis_bottomfooter__ax6bG","Container":"Footer_Dis_Container__SW58O"};